import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = { class: "tw-pb-4 tw-space-y-6" };
const _hoisted_2 = { class: "tw-space-y-3" };
const _hoisted_3 = { class: "tw-flex tw-items-center tw-w-full tw-justify-between md:tw-flex-row tw-flex-col md:tw-gap-0 tw-gap-5" };
const _hoisted_4 = { class: "tw-flex tw-items-center tw-flex-wrap" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "tw-flex tw-justify-between tw-px-4 tw-py-2 hover:tw-text-primary tw-text-[#738499] tw-text-[13px] tw-font-medium tw-truncate tw-items-center" };
const _hoisted_7 = { class: "tw-flex tw-gap-3 hover:tw-text-primary" };
const _hoisted_8 = { class: "tw-group group-hover:tw-text-primary tw-text-[#738499] tw-text-[13px] tw-font-medium tw-truncate" };
const _hoisted_9 = { class: "tw-flex tw-items-center tw-relative tw-gap-3 sm:tw-flex-nowrap tw-flex-wrap" };
const _hoisted_10 = { class: "tw-group group-hover:tw-text-primary tw-text-[#fff] tw-text-[13px] tw-truncate" };
const _hoisted_11 = {
    key: 1,
    class: "tw-bg-[#230F41] !tw-opacity-1 tw-absolute tw-overflow-auto tw-h-[300px] tw-top-11 tw-right-0 tw-z-[9999999] tw-w-full"
};
const _hoisted_12 = { class: "tw-flex tw-gap-3 hover:tw-text-primary" };
const _hoisted_13 = { class: "tw-group group-hover:tw-text-primary tw-text-[#fff] tw-text-[13px] tw-font-medium tw-truncate" };
const _hoisted_14 = {
    key: 0,
    class: "tw-pb-4 tw-space-y-6"
};
const _hoisted_15 = { class: "tw-space-y-3" };
const _hoisted_16 = { class: "tw-w-full tw-p-0 tw-mb-0" };
const _hoisted_17 = { class: "tw-transition-all tw-duration-300 tw-ease-in-out tw-border-l-2 tw-cursor-pointer tw-text-[#738499] tw-group tw-border-l-transparent" };
const _hoisted_18 = { class: "tw-group tw-text-[#fff] tw-text-[18px] tw-font-medium tw-truncate" };
const _hoisted_19 = {
    key: 0,
    class: "tw-w-full"
};
const _hoisted_20 = { class: "tw-flex tw-items-center tw-gap-4 2xl:tw-gap-3 tw-rounded tw-cursor-pointer tw-w-full tw-h-full" };
const _hoisted_21 = ["src", "alt"];
const _hoisted_22 = {
    key: 1,
    class: "tw-w-full tw-my-5"
};
const _hoisted_23 = { class: "single-slide" };
const _hoisted_24 = { class: "box" };
const _hoisted_25 = { class: "img-box" };
const _hoisted_26 = ["src", "alt"];
const _hoisted_27 = {
    key: 1,
    class: "tw-text-center tw-text-sm tw-text-gray-500"
};
import { ref, onMounted, onUnmounted, watch } from "vue";
import { useRouter } from "vue-router";
import { useLogo } from "@/hooks/useLogo";
import { useSidebar } from "@/stores/sidebar";
import { Carousel, Slide } from "vue3-carousel";
import GamesByProviders from "./GamesByProviders.vue";
// Props
export default /*@__PURE__*/ _defineComponent({
    __name: 'CasinoComponentForAll',
    props: {
        games: {},
        casinoSideBarCategories: {},
        gameCategories: {},
        selectedCategory: {},
        isLoading: { type: Boolean }
    },
    emits: ["viewGames"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const gameUrl = ref(null);
        const scrollContainer = ref(null);
        const router = useRouter();
        const logo = useLogo();
        const { handleCloseSidebar } = useSidebar();
        const activeAccordion = ref(null);
        // Search query ref
        const searchQuery = ref('');
        // Function to check if a category or game is selected
        const isSelected = (href) => router.currentRoute.value.path === href;
        const filteredGames = (gameCat) => {
            return props.games.filter((game) => game.gamebank === gameCat.gameType &&
                game.name.toLowerCase().includes(searchQuery.value.toLowerCase()));
        };
        const showProviders = ref(false);
        const toggleProviders = () => {
            showProviders.value = !showProviders.value;
        };
        const activeCategoryId = ref(null);
        const toggleView = (categoryId) => {
            emit('viewGames', { title: 'All', id: null });
            router.replace({ path: '/casino/all' });
            activeCategoryId.value = activeCategoryId.value === categoryId ? null : categoryId;
        };
        const config = ref({
            itemsToShow: 6,
            autoplay: 3000,
            infinite: true,
            gap: 10,
        });
        const screenWidth = ref(window.innerWidth);
        watch(screenWidth, (newWidth) => {
            if (newWidth < 640) {
                config.value.itemsToShow = 3;
            }
            else {
                config.value.itemsToShow = 6;
            }
        });
        // Update screenWidth on window resize
        onMounted(() => {
            const handleResize = () => {
                screenWidth.value = window.innerWidth;
            };
            window.addEventListener("resize", handleResize);
            onUnmounted(() => {
                window.removeEventListener("resize", handleResize);
            });
        });
        return (_ctx, _cache) => {
            const _component_RouterLink = _resolveComponent("RouterLink");
            const _component_CardContent = _resolveComponent("CardContent");
            const _component_Card = _resolveComponent("Card");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("nav", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("ul", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("li", {
                                    class: _normalizeClass(["tw-transition-all tw-duration-300 tw-ease-in-out tw-border-b-2 tw-cursor-pointer tw-group hover:tw-font-medium hover:tw-border-b-primary hover:tw-text-primary hover:tw-bg-hover", {
                                            'tw-border-b-primary tw-text-primary tw-bg-hover': activeCategoryId.value === null,
                                            'tw-text-[#738499] tw-border-b-transparent': activeCategoryId.value !== null
                                        }]),
                                    onClick: _cache[0] || (_cache[0] = ($event) => (toggleView(null)))
                                }, _cache[2] || (_cache[2] = [
                                    _createElementVNode("div", { class: "tw-flex tw-gap-3 tw-px-4 tw-py-2 hover:tw-text-primary" }, [
                                        _createElementVNode("p", { class: "tw-group group-hover:tw-text-primary tw-text-white tw-text-[13px] tw-font-medium tw-truncate" }, " All Games ")
                                    ], -1)
                                ]), 2),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.casinoSideBarCategories, (gameCat) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: gameCat.id,
                                        class: "tw-border-none tw-p-0"
                                    }, [
                                        _createElementVNode("li", {
                                            class: _normalizeClass(["tw-transition-all tw-duration-300 tw-ease-in-out tw-border-b-2 tw-cursor-pointer tw-group hover:tw-font-medium hover:tw-border-b-primary hover:tw-text-primary hover:tw-bg-hover", {
                                                    'tw-border-b-primary tw-text-primary tw-bg-hover': activeCategoryId.value === gameCat.id,
                                                    'tw-text-[#738499] tw-border-b-transparent': activeCategoryId.value !== gameCat.id
                                                }]),
                                            onClick: ($event) => (toggleView(gameCat.id))
                                        }, [
                                            _createElementVNode("div", _hoisted_6, [
                                                _createElementVNode("div", _hoisted_7, [
                                                    _createElementVNode("p", _hoisted_8, _toDisplayString(gameCat.name), 1)
                                                ])
                                            ])
                                        ], 10, _hoisted_5)
                                    ]));
                                }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                                (activeCategoryId.value !== null)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(_ctx.selectedCategory && _ctx.selectedCategory.title === 'All' ? 'tw-max-w-[200px] tw-block' : 'tw-hidden')
                                    }, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((searchQuery).value = $event)),
                                            type: "text",
                                            placeholder: "Search Games",
                                            class: "tw-border placeholder:tw-text-sm tw-border-solid tw-px-4 tw-text-sm tw-py-1"
                                        }, null, 512), [
                                            [_vModelText, searchQuery.value]
                                        ])
                                    ], 2))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                    class: "tw-flex tw-gap-3 hover:tw-text-primary tw-cursor-pointer tw-border-[2px] tw-border-[#A1ff00] tw-px-4 tw-py-1 tw-rounded-2xl",
                                    onClick: toggleProviders
                                }, [
                                    _createElementVNode("p", _hoisted_10, [
                                        _cache[3] || (_cache[3] = _createTextVNode(" Select Provider ")),
                                        _createElementVNode("img", {
                                            class: _normalizeClass(showProviders.value ? 'tw-w-3 tw-h-3 tw-ml-1 tw-inline tw-rotate-180 tw-transition-all tw-duration-150' : 'tw-w-3 tw-h-3 tw-ml-1 tw-inline  tw-rotate-0 tw-transition-all tw-duration-150 '),
                                            src: "/assets/images/svg/c-down-arrow.svg",
                                            alt: "icon"
                                        }, null, 2)
                                    ])
                                ]),
                                (showProviders.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createElementVNode("ul", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameCategories, (category) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                    key: category.title,
                                                    class: _normalizeClass(["tw-transition-all tw-duration-300 tw-ease-in-out tw-border-l-2 tw-cursor-pointer tw-text-[#738499] tw-group tw-border-l-transparent hover:tw-font-medium hover:tw-border-l-primary hover:tw-text-primary hover:tw-bg-hover", { 'tw-text-primary tw-font-medium tw-border-l-primary tw-bg-hover': isSelected(category.href) }])
                                                }, [
                                                    _createVNode(_component_RouterLink, {
                                                        to: category.href,
                                                        class: "tw-flex tw-justify-between hover:tw-text-primary tw-text-[#738499] tw-text-[13px] tw-font-medium tw-truncate tw-items-center tw-px-2 tw-py-1"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_12, [
                                                                _createElementVNode("p", _hoisted_13, _toDisplayString(category.title), 1)
                                                            ])
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["to"])
                                                ], 2));
                                            }), 128))
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ]),
                (_ctx.selectedCategory && _ctx.selectedCategory.title === 'All')
                    ? (_openBlock(), _createElementBlock("nav", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.casinoSideBarCategories, (gameCat) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: gameCat.id,
                                        class: "tw-border-none tw-p-0"
                                    }, [
                                        (!activeCategoryId.value || activeCategoryId.value === gameCat.id)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createElementVNode("div", _hoisted_16, [
                                                    _createElementVNode("div", _hoisted_17, [
                                                        _createElementVNode("div", {
                                                            class: _normalizeClass(["tw-flex tw-gap-4 tw-py-4 tw-text-[#738499] tw-text-[13px] tw-font-medium tw-truncate tw-items-center", activeCategoryId.value === gameCat.id ? 'tw-justify-between' : ''])
                                                        }, [
                                                            _createElementVNode("p", _hoisted_18, _toDisplayString(gameCat.name), 1)
                                                        ], 2)
                                                    ])
                                                ]),
                                                (activeCategoryId.value === gameCat.id)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                        _createVNode(_component_Card, { class: "tw-border-none tw-pb-6 tw-w-full tw-bg-transparent" }, {
                                                            default: _withCtx(() => [
                                                                (filteredGames(gameCat).length)
                                                                    ? (_openBlock(), _createElementBlock("div", {
                                                                        key: 0,
                                                                        ref_for: true,
                                                                        ref_key: "scrollContainer",
                                                                        ref: scrollContainer,
                                                                        class: "tw-max-h-[calc(100vh-180px)] tw-overflow-auto"
                                                                    }, [
                                                                        _createVNode(_component_CardContent, { class: "scroller tw-grid tw-grid-cols-3 lg:tw-grid-cols-4 xl:tw-grid-cols-5 2xl:tw-grid-cols-5 tw-gap-4" }, {
                                                                            default: _withCtx(() => [
                                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredGames(gameCat), (game) => {
                                                                                    return (_openBlock(), _createElementBlock("div", {
                                                                                        key: game.id
                                                                                    }, [
                                                                                        _createElementVNode("div", _hoisted_20, [
                                                                                            _createElementVNode("img", {
                                                                                                src: `https://azurecoinz.com/frontend/Default/ico/${game.name}.jpg`,
                                                                                                alt: game.name,
                                                                                                class: "tw-object-cover tw-rounded tw-w-full tw-h-full"
                                                                                            }, null, 8, _hoisted_21)
                                                                                        ])
                                                                                    ]));
                                                                                }), 128))
                                                                            ]),
                                                                            _: 2
                                                                        }, 1024)
                                                                    ], 512))
                                                                    : _createCommentVNode("", true)
                                                            ]),
                                                            _: 2
                                                        }, 1024)
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                        _createVNode(_component_Card, { class: "tw-border-none tw-pb-6 tw-w-full tw-bg-transparent" }, {
                                                            default: _withCtx(() => [
                                                                (filteredGames(gameCat).length)
                                                                    ? (_openBlock(), _createElementBlock("div", {
                                                                        key: 0,
                                                                        ref_for: true,
                                                                        ref_key: "scrollContainer",
                                                                        ref: scrollContainer,
                                                                        class: "tw-max-h-[300px] tw-overflow-auto"
                                                                    }, [
                                                                        _createVNode(_unref(Carousel), _mergeProps({ ref_for: true }, config.value), {
                                                                            default: _withCtx(() => [
                                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredGames(gameCat), (game) => {
                                                                                    return (_openBlock(), _createBlock(_unref(Slide), {
                                                                                        key: game.id
                                                                                    }, {
                                                                                        default: _withCtx(() => [
                                                                                            _createElementVNode("div", _hoisted_23, [
                                                                                                _createElementVNode("div", _hoisted_24, [
                                                                                                    _createElementVNode("div", _hoisted_25, [
                                                                                                        _createElementVNode("img", {
                                                                                                            src: `https://azurecoinz.com/frontend/Default/ico/${game.name}.jpg`,
                                                                                                            alt: game.name,
                                                                                                            class: "tw-object-cover tw-rounded tw-w-full tw-h-full"
                                                                                                        }, null, 8, _hoisted_26)
                                                                                                    ])
                                                                                                ])
                                                                                            ])
                                                                                        ]),
                                                                                        _: 2
                                                                                    }, 1024));
                                                                                }), 128))
                                                                            ]),
                                                                            _: 2
                                                                        }, 1040)
                                                                    ], 512))
                                                                    : (_openBlock(), _createElementBlock("p", _hoisted_27, " No games available "))
                                                            ]),
                                                            _: 2
                                                        }, 1024)
                                                    ]))
                                            ], 64))
                                            : _createCommentVNode("", true)
                                    ]));
                                }), 128))
                            ])
                        ])
                    ]))
                    : (_openBlock(), _createBlock(GamesByProviders, {
                        key: 1,
                        games: _ctx.games,
                        selectedCategory: _ctx.selectedCategory,
                        isLoading: _ctx.isLoading
                    }, null, 8, ["games", "selectedCategory", "isLoading"]))
            ], 64));
        };
    }
});
